import { FC } from 'react';
import { Landing } from '../../../../modules/authentication/components/landing/landing';

export const LandingRoute: FC = () => {
  return <Landing />;
};
